import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Footer from './components/Footer';
import NotFound from './pages/NotFound';
import Preloader from './components/PreLoader';
import CustomCursor from './components/ui/CustomCursor';
import KonamiEgg from './components/ui/KonamiEgg';
import CodeRain from './components/ui/CodeRain';
import TechMarquee from './components/TechMarquee';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      {isLoading && <Preloader onLoaded={() => setIsLoading(false)} />}
      <CodeRain />
      <CustomCursor />
      <KonamiEgg />
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Stats />
              <About />
              <Skills />
              <TechMarquee />
              <Projects />
              <Experience />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
